<template>
  <div class="home hardlist-home">
    <HardwareLayout
      layoutType="HARDLIST"
      :layoutTitile="$t('layoutTitile')"
    >
      <BasiceLayout :title="$t('hardListLayoutTitile')">
        <div class="hardware-content">
          <!-- mac地址搜索 -->
          <div
            class="hardware-search-wrap"
            v-if="allDevices"
            align='center'
          >
            <!-- <span class="search-text">{{$t('mac_address')}}</span>
            <el-input
              class="search-mac-input"
              v-model="searchMacAddress"
              placeholder=""
              @change="search"
            ></el-input> -->
            <!--  -->
            <div class="unbind-more-button">
              <!-- .length -->
              <div
                v-if="hardList !== 'NO_CONTENT' && hardList"
                type="danger"
                @click="changeUnbindStatus(true)"
                v-bind:class="[{'background-ddd': multipleUnbindStatus}, 'unbind-button', 'bonus-cursor']"
              >{{ $t('unbindMore') }}</div>
              <div
                type="danger"
                v-if="multipleUnbindStatus"
                @click="unbindMultDevices()"
                class="button bonus-cursor"
              >{{ $t('sure') }}</div>
              <div
                type="danger"
                v-if="multipleUnbindStatus"
                @click="changeUnbindStatus(false)"
                class=" unbind-button bonus-cursor "
              >{{ $t('cancel') }}</div>
            </div>
          </div>
          <!-- 硬件列表 -->
          <el-table
            ref="multipleTable"
            v-if="hardList !== 'NO_CONTENT'"
            :data="hardList"
            align="left"
            empty-text="Loading..."
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              v-if="multipleUnbindStatus"
              type="selection"
              width="55"
            >
            </el-table-column>
            <!-- serverid -->
            <el-table-column
              prop="serverID"
              label="serverID"
              align='center'
            >
            </el-table-column>
            <!-- 主机名 -->
            <el-table-column
              prop="serverHostname"
              :label="$t('hostName')"
              align='center'
            >
            </el-table-column>
            <!-- mac address -->
            <el-table-column
              prop="mac_address"
              :label="$t('macAddress')"
              align='center'
            >
            </el-table-column>
            <!-- 备注 -->
            <el-table-column
              :label="$t('noteText')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.note">{{scope.row.note}}</div>
                <div
                  v-if="!scope.row.note"
                  :deviceId="scope.row.deviceId"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                  class="add-note-button button bonus-cursor"
                >
                  {{$t('addNote')}}</div>
                <i
                  v-if="scope.row.note && scope.row.noteStatus"
                  class="el-icon-edit"
                  @click="showNotes(scope.row.id, scope.row.mac_address)"
                ></i>
              </template>
            </el-table-column>

            <!-- 资源类型 -->
            <el-table-column
              :label="$t('resourceType')"
              align='center'
            >
              <template slot-scope="scope">
                <div>{{scope.row.serverNetType == 0 ? '静态IP专线' : '动态IP汇聚'}}</div>
              </template>
            </el-table-column>

            <!-- 绑定时间 -->
            <el-table-column
              prop="bind_at"
              empty-text="-"
              :label="$t('date')"
              align='center'
            >
            </el-table-column>
            <!-- 管理IP -->
            <el-table-column
              prop=""
              label="管理IP"
              align='center'
            >
              <template slot-scope="scope">
                <div >{{scope.row.serverJumperIP || '-'}}</div>
              </template>
            </el-table-column>
            <!-- 密码 -->
<!--            <el-table-column
              label="登陆密码"
              align='center'
            >
              <template slot-scope="scope">
                <div class="bonus-color" @click="showPassword(scope.row.bcode)">查看密码</div>
              </template>
            </el-table-column> -->
            <!-- 在线状态 -->
            <el-table-column
              prop=""
              :label="$t('netStatus')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.status">-</div>
                <el-tag
                  v-if="scope.row.status === 'online'"
                  type="success"
                >online</el-tag>
                <el-tag
                  v-if="scope.row.status === 'offline'"
                  type="danger"
                >offline</el-tag>
              </template>
            </el-table-column>
            <!-- 消息报警同志 -->
            <!-- <el-table-column
              prop=""
              :label="$t('notice')"
              align='center'
            >
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.report"
                  active-color="#13ce66"
                  @change="changeNotify(scope.row)"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </template>
            </el-table-column> -->
            <!-- 操作 -->
            <el-table-column
              min-width="130px"
              align='center'
            >
              <template slot-scope="scope">
                <div class="operation">
                  <!-- 解绑 -->
                  <button
                    type="danger"
                    :deviceId="scope.row.id"
                    :disabled='multipleUnbindStatus'
                    v-bind:class="[{'background-ddd': multipleUnbindStatus}, 'unbind-button', 'bonus-cursor']"
                    @click="checkUnBind(scope.row.id)"
                  >{{$t('unbindButton')}}</button>
                  <!-- restart -->
                  <!-- <div
                    type="danger"
                    :deviceId="scope.row.id"
                    v-if="scope.row.info === 'v0.4.4' || scope.row.info === 'v0.4.5'"
                    @click="checkRestart(scope.row.id)"
                    class="button restart-button bonus-cursor"
                  >{{$t('restartButton')}}</div> -->
                  <!-- <div
                    class="restart-info"
                    v-if="scope.row.info !== 'v0.4.4' && scope.row.info !== 'v0.4.5'"
                  >-</div> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="pagination"
            v-if="deviceSize > 1"
          >
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="deviceSize"
              layout="total, prev, pager, next"
              :total="hardLength"
            >
            </el-pagination>
          </div>
          <el-table
            v-if="hardList === 'NO_CONTENT'"
            :empty-text="$t('noHardwareTip')"
            style="width: 100%"
          >
          </el-table>
        </div>
      </BasiceLayout>
    </HardwareLayout>
    <!-- 重启 -->
    <el-dialog
      :title="$t('restartDialog')"
      :visible.sync="showRestartDialog"
      width="480px"
      center
    >
      <div class="restartSureTips">{{ $t('restartSureTips') }}</div>
      <div class="restartWrap">
        <div
          class="sure-unbind button"
          type="primary"
          @click="sureRestartDevice"
        >{{ $t('sure') }}</div>
        <div
          class="sure-unbind button"
          @click="showRestartDialog = false"
        >{{ $t('cancel') }}</div>
      </div>
    </el-dialog>
    <!-- 解绑 -->
    <el-dialog
      title="设备解绑"
      :visible.sync="showUnbindDialog"
      width="480px"
      center
    >
      <div class="unbind-dialog-wrap" style="margin-bottom: -30px;">
        <span class="key">图片验证</span>
        <div class="hard-captcha">
          <div style="display: flex;align-items: center; justify-content: space-between;">
            <input
              type="text"
              class="input"
              style="width: 100px; font-size: 12px; height: 40px;"
              v-model="imageCode"
              autocomplete="off"
            />
            <img style="margin-left: 10px; width: 90px;":src="imgUrl" />
            <div style="width: 110px;">
              <p style="margin-left: 10px; font-size: 14px;" class="image-remark">看不清？<span style="color: #12B8B6; cursor: pointer;text-decoration: underline;" @click="queryimageCode">换一张</span></p>
            </div>
          </div>
        </div>
      </div>
      <div class="unbind-dialog-wrap" style="margin-bottom: -30px;">
        <span class="key mail-key">手机验证</span>
        <SendEmailCode
          type="text"
          imageStyle="unbind-style"
          :response="response"
          class="unbind-input password-email"
          v-model="inputEmailCode"
          needImageCode=true
          :email="email"
          @emailCodeTip="emailCodeTip"
        ></SendEmailCode>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showUnbindDialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="unbind"
        >{{ $t('sure') }}</div>
      </span>
    </el-dialog>
    <!-- 解绑多个设备控制板 -->
    <el-dialog
      :title="$t('multiUnbindDialog')"
      :visible.sync="showUnbindConsole"
      width="540px"
      center
    >
      <div class="muilt-unbind-wrap">
        <div v-for="item in multUnbindInfo">{{item}}</div>
        <span
          v-if="showDotting"
          class="dotting"
        ></span>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          type="primary"
          @click="resetMultiUnbind"
        >{{ $t('sure') }}</div>
      </span>
    </el-dialog>
    <!-- 增加备注 -->
    <el-dialog
      :title="$t('addNotes.title')"
      :visible.sync="showAddnoteDialog"
      width="480px"
      center
    >
      <div class="addnote-dialog-wrap">
        <span class="key">{{$t('addNotes.tipText')}}({{addNoteAddress}})</span>
        <input
          type="text"
          class="basic-input input addnote-input"
          v-model="addNoteInput"
        >
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showAddnoteDialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="addNote"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog>
    <!-- 增加备注-->

     <!-- 查看密码对话框  -->
<!-- <el-dialog
      title="查看密码"
      :visible.sync="showPasswordialog"
      width="480px"
      center
    >
       <div class="unbind-dialog-wrap">
        <span class="key verify-key">{{$t('dialog.imageVerify')}}</span>
        <div class="hard-captcha">
          <!-- 谷歌验证 -->
<!--          <vue-recaptcha
            class="captcha-wrap"
            ref="recaptcha"
            @verify="onVerify"
            @expired="onExpired"
            data-size="normal"
            :sitekey="sitekey"
          />
        </div>
      </div>
      <div class="unbind-dialog-wrap">
        <span class="key mail-key">{{$t('dialog.mailText')}}</span>
        <SendEmailCode
          type="text"
          imageStyle="unbind-style"
          :response="response"
          class="unbind-input password-email"
          v-model="inputEmailCode"
          needImageCode=true
          :email="email"
          @emailCodeTip="emailCodeTip"
        ></SendEmailCode>
      </div> -->
<!--      <span
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="sure-unbind button"
          @click="showPasswordialog = false"
        >{{ $t('cancel') }}</div>
        <div
          class="sure-unbind button"
          type="primary"
          @click="searchPassword"
        >{{ $t('confirm') }}</div>
      </span>
    </el-dialog> -->
  </div>
</template>

<i18n>
{
    "en": {
    "layoutTitile": "Hardware List",
    "hardListLayoutTitile": "Hardware List",

    "date": "The Binding Date(UTC)",
    "code": "Binding BonusCode",
    "totalTime": "Total Online Time",
    "unbindButton": "Unbind",
    "dialog": {
      "cancel": "Cancel",
      "title": "Confirm Unbinding",
      "mailText": "Email Verfication Code",
      "imageVerify": "Image Verfication"
    },
    "allSearch": "All",
    "restartButton": "Restart",
    "restartSureTips": "The device is about to restart, please do not repeat the operation",
    "restartDialog": "Tips",
    "unbindMore": "Unbind multiple devices",
    "unSelected": "The device to unbind is not selected",
    "multiUnbindDialog": "Unbind Logs",
    "notice": "notice",

    "hostName": "Host Name",
    "resourceType": "Resource Type"

  },
  "zn": {
    "layoutTitile": "节点列表",
    "hardListLayoutTitile": "标准节点",
    "date": "绑定时间(UTC)",
    "code": "已绑定激活码 ",
    "totalTime": "累计在线时长",
    "unbindButton": "解绑",
    "allSearch": "全部",
    "restartButton": "重启",
    "restartSureTips": "设备即将重启，请勿重复操作",
    "restartDialog": "提示",
    "unbindMore": "批量解绑",
    "unSelected": "未选中要解绑的设备",
    "multiUnbindDialog": "解绑日志",
    "notice": "故障通知开关",
    "hostName": "主机名",
    "resourceType": "资源类型"


  }
}
</i18n>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import AccountSetLayout from "@/components/AccountSet/AccountSetLayout.vue";
import HardwareLayout from "@/components/Hardware/HardwareLayout.vue";
import SendEmailCode from "@/components/SendEmailCode.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG, SITEKEY } from "../../config/contant.js";
import VueRecaptcha from "vue-recaptcha";
const nologin_dev = "true";
const deviceType = "normal";
import { reqUrl } from '../../utils/env';
import axios from 'axios';

export default {
  name: "home",
  components: {
    BasiceLayout,
    AccountSetLayout,
    SendEmailCode,
    HardwareLayout,
    VueRecaptcha
  },
  data() {
    return {
      unbindId: "", //解绑Id
      showUnbindDialog: false, // 绑定弹框展示
      restartId: "", //解绑Id
      showRestartDialog: false, // 重启弹框提示
      showAddnoteDialog: false, //添加备注
      showDeviceBindDialog: false, //设备绑定信息弹框
      showDeviceInfo: false, //设备硬件信息弹框
      addNoteInput: "",
      addNoteId: "", //添加备注Id
      addNoteAddress: "", //添加备注Id
      watchId: "",
      inputEmailCode: "", //输入的邮件码
      response: "",
      sitekey: SITEKEY["LOW"], //ga verify key
      searchMacAddress: "",
      searchWatchDate: moment()
        .utc()
        .startOf("day")
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      stableCharts: {},
      availabilityChart: {},
      hardOnlineChart: {},
      // txBwCharts: {},
      hardOnlineColumns: false,
      chartSettings: {
        metrics: ["日期"],
        dimension: ["网络资源可用性"]
      },
      showCharts: "waiting",
      bindAt: "", //设备绑定时间
      ip: "", //设备IP
      version: "",
      mem_size: "",
      multipleSelection: [], //选中的多个解绑设备
      multipleUnbindStatus: false, //解绑多个设备状态
      multUnbindInfo: [], //解绑多个设备日志
      showUnbindConsole: false, //解绑多个设备控制台展示
      showDotting: false,
      // showPasswordialog: false,
      showPassBcode: "",
      imageCode:'',
      imgUrl: '',
      imageCodeId: ''
    };
  },
  computed: mapState({
    hardList: state => state.hardWare.list,
    hardLength: state => state.hardWare.hardLength,
    deviceSize: state => state.hardWare.deviceSize,
    currentPage: state => state.hardWare.currentPage,
    email: state => state.account.email,
    allDevices: state => state.hardWare.allDevices,
    queryDate: () => {
      let queryDate = [];
      let endDay = moment()
        .utc()
        .startOf("day");
      endDay -= 24 * 60 * 60 * 1000;
      let i = 0;
      while (i < 7) {
        i++;
        queryDate.push(moment(endDay).format("YYYY-MM-DD"));
        endDay -= 24 * 60 * 60 * 1000;
      }
      return queryDate;
    }
  }),
  methods: {
    ...mapActions([
      "getHardList",
      "unbindHard",
      "getDeviceDetail",
      "addDeviceNotes",
      "getDeviceWatchDetail",
      "restartDevice",
      "setNotify",
      "getPassword"
    ]),
    queryimageCode() {
      this.imageCode = '';
      try {
        axios.get(`${reqUrl}/api/getCaptcha`).then(res=>{
          this.imgUrl = res.data.data.Base64Blob;
          this.imageCodeId = res.data.data.CaptchaId;
        })
      } catch (error) {
          this.imgUrl = '';
          this.imageCodeId = '';
      }
    },
    change() {
      this.changePw({
        oldPassword: this.oldPw,
        newPassword: this.newPw,
        reNewPassword: this.newSecPw
      });
    },
    checkUnBind(id) {
      this.showUnbindDialog = true;
      this.unbindId = id;
      this.imageCode = '';
      this.inputEmailCode = '';
      this.imageCodeId = '';
      this.queryimageCode();
    },
    checkRestart(id) {
      this.showRestartDialog = true;
      this.restartId = id;
    },
    // 添加备注
    addNote() {
      let that = this;

      if (!this.addNoteInput) {
        return;
      }
      this.addDeviceNotes({
        deviceId: this.addNoteId,
        note: this.addNoteInput
      }).then(res => {
        if (res.code === 200) {
          Message({
            type: "success",
            message: res.message
          });
          that.showAddnoteDialog = false;
          if (that.searchMacAddress === "all" || that.searchMacAddress === "") {
            that.getHardList({
              pageNum: that.currentPage,
              nologin_dev,
              deviceType
            });
          } else {
            this.getDeviceDetail({ id: that.searchMacAddress });
          }
        } else {
          Message({
            type: "error",
            message: res.message || "add note error"
          });
        }
      });
    },
    showNotes(id, address) {
      this.showAddnoteDialog = true;
      this.addNoteId = id;
      this.addNoteAddress = address;
    },
    // 重启
    sureRestartDevice() {
      let device_id = this.restartId;
      let that = this;
      this.restartDevice({
        device_id,
        timeout: 10
      }).then(res => {
        that.showRestartDialog = false;
      });
    },
    // 搜索
    search() {
      if (this.searchMacAddress === "all") {
        this.getHardList({ pageNum: 1, nologin_dev, deviceType });
      } else {
        // this.getDeviceDetail({ id: this.searchMacAddress });
        this.getDeviceDetail({ macAddress: this.searchMacAddress });
      }
    },
    // 解绑
    unbind() {
      //  单个解绑
      if (!this.multipleUnbindStatus) {
        if(!this.imageCode.trim()) {
          return Message({
            type: "error",
            message: '图片验证码不能为空'
          });
        }
        if(!this.inputEmailCode) {
          return Message({
            type: "error",
            message: '手机验证码不能为空'
          });
        }
        this.unbindHard({ 
          deviceId: this.unbindId,
          emailVerifyCode: this.inputEmailCode,
          imageCodeId: this.imageCodeId,
          imageCode: this.imageCode,
        }).then(res => {
          if (res.code === 200) {
            // 刷新硬件列表
            this.getHardList({ pageNum: this.currentPage, nologin_dev, deviceType });
            this.showUnbindDialog = false;
            Message({
              type: "success",
              message: res.message
            });
            // window.location.reload()
          } else {
            this.queryimageCode();
            Message({
              type: "error",
              message: res.message || "unbind error"
            });
          }
        });
      } else {
        let { id, mac_address } = this.multipleSelection[0];
        this.multipleSelection = this.multipleSelection.slice(1);

        // if(!this.imageCode.trim()) {
        //   return Message({
        //     type: "error",
        //     message: '图片验证码不能为空'
        //   });
        // }
        // if(!this.inputEmailCode) {
        //   return Message({
        //     type: "error",
        //     message: '手机验证码不能为空'
        //   });
        // }

        this.unbindHard({
          deviceId: id,
          emailVerifyCode: this.inputEmailCode,
          // imageCodeId: this.imageCodeId,
          // imageCode: this.imageCode,
        }).then(res => {
          this.showUnbindDialog = false; //隐藏解绑验证码框
          this.showUnbindConsole = true; //展示控制台
          this.showDotting = true; //展示...
          if (res.code === 200) {
            // 刷新硬件列表
            this.multUnbindInfo.push(`${mac_address}: SUCCESS`);
          } else {
            Message({
              type: "error",
              message: res.message || "unbind error"
            });
            this.multUnbindInfo.push(`${mac_address}: ERROR`);
          }
          // 解绑完重置验证码
          if (!this.multipleSelection.length) {
            // this.resetRecaptcha();
            this.getHardList({ pageNum: this.currentPage, nologin_dev, deviceType });
            this.showDotting = false;
            this.multipleUnbindStatus = false;
          } else {
            this.unbind();
          }
        });
      }
    },
    resetMultiUnbind() {
      this.showUnbindConsole = false;
      this.multUnbindInfo = [];
    },
    // email错误提示
    emailCodeTip(error) {
      if (error.message) {
        Message({
          type: "error",
          message: error.message
        });
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getHardList({ pageNum: val, nologin_dev, deviceType });
    },
    // 头部提示设置
    renderHeader: function(creatElement, { column, $index }) {
      let fields = this.fields;
      return creatElement("div", [
        column.label,
        creatElement(
          "el-tooltip",
          {
            class: "cell-s-tip",
            props: {
              content: (function() {
                let label = column.label;
                switch (label) {
                  case "节点网络质量":
                    return "节点网络质量表示当前设备的网络稳定情况，掉线、延迟、丢包等网络情况都会导致网络质量变差，网络质量出现波动后，需要1小时逐步恢复。";
                    break;
                  case "Node Stability":
                    return "The node network quality refers to the network stability of the corresponding device, and the situations, such as disconnection, time delay and packet loss, affect the network quality. It will take 1 hour for the gradual recovery after the fluctuation of the network quality occuring.";
                    break;
                  case "网络资源可用性":
                    return "网络资源可用时才可以获得网络任务收益，可用性受节点网络质量影响，当网络质量为低时，网络资源不可用，无法获得网络任务收益。";
                    break;
                  case "Network Resource Availability":
                    return "The network task revenue can be obtained when network resource is available, and the availability is influenced by the the node network quality. If the quality is low, the network resource will be in status of 'not available', and no network task revenue will be released.";
                    break;
                }
              })(),
              effect: "dark",
              placement: "top"
            }
          },
          [
            creatElement("i", {
              class: "fa fa-question-circle revenue-icon el-icon-question"
            })
          ]
        )
      ]);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeUnbindStatus(status) {
      this.multipleUnbindStatus = status;
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
    },
    // 解绑多个设备
    unbindMultDevices() {
      // 处理为选中状态
      if (!this.multipleSelection.length) {
        return Message({
          message: this.$t("unSelected"),
          type: "error"
        });
      }
      this.showUnbindDialog = true;
      this.imageCode = '';
      this.inputEmailCode = '';
      this.imageCodeId = '';
      this.unbindId = this.multipleSelection;
      this.queryimageCode();
    },
    //消息通知
    changeNotify(row) {
      let {id, report} = row;
      this.setNotify({
        report,
        device_id: id
      }).then(item => {
        this.getHardList({ pageNum: 1, nologin_dev, deviceType });
      });
    },
    // 查看密码
    // showPassword(bcode) {
    //   console.log(bcode)
    //   this.showPasswordialog = true;
    //   this.showPassBcode = bcode;
    // },
    searchPassword() {
      let { showPassBcode, inputEmailCode } = this;
      this.getPassword({emailVerifyCode: inputEmailCode, showPassBcode}).then(res => {
        if (res.code === 200) {
          this.$alert(res.data, '密码', {
            confirmButtonText: '确定',
          });
          this.$refs.recaptcha.reset();
          this.showPasswordialog = false;
        } else {
          Message({
            message: res.message || '网络超时，请重试',
            type: "error"
          });
          this.$refs.recaptcha.reset();
        }
      })
    }
  },
  async created() {
    this.queryimageCode();
    await this.getHardList({ pageNum: 1, nologin_dev, deviceType });
    console.log(this.hardList);
  }
};
</script>

<style lang="stylus">
.hardware-search-wrap{
  min-height: 30px
}
</style>
